import request from '@/api/http'

/**
 * 上传结算单附件
 * @param {FormData} formData - 包含文件和附件信息的表单数据
 * @param {File} formData.file - 附件文件
 * @param {Number} formData.settlementId - 结算单ID
 * @param {String} [formData.description] - 附件描述
 * @param {Number} formData.uploaderId - 上传人ID
 * @returns {Promise} 返回上传结果的Promise对象
 */
export function upload_settlement_attachment(formData) {
  return request({
    url: '/settlement-attachments/upload',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

/**
 * 获取结算单附件列表
 * @param {Number} settlementId - 结算单ID
 * @returns {Promise} 返回附件列表的Promise对象
 */
export function get_settlement_attachments(settlementId) {
  return request({
    url: `/settlement-attachments/settlement/${settlementId}`,
    method: 'get'
  })
}

/**
 * 分页查询结算单附件列表
 * @param {Object} params - 查询参数
 * @param {Number} params.settlementId - 结算单ID（必填）
 * @param {Number} [params.uploaderId] - 上传人ID（可选）
 * @param {String} [params.fileType] - 文件类型（可选）
 * @param {String} [params.originalName] - 原始文件名（可选）
 * @param {Number} [params.page] - 页码，默认0
 * @param {Number} [params.size] - 每页大小，默认10
 * @param {String} [params.sortBy] - 排序字段，默认uploadTime
 * @param {String} [params.sortDirection] - 排序方向，默认desc
 * @returns {Promise} 返回分页附件列表的Promise对象
 */
export function get_settlement_attachments_pagination(params) {
  return request({
    url: '/settlement-attachments/page',
    method: 'get',
    params
  })
}

/**
 * 下载结算单附件
 * @param {Number} attachmentId - 附件ID
 * @returns {Promise} 返回文件流的Promise对象
 */
export function download_settlement_attachment(attachmentId) {
  return request({
    url: `/settlement-attachments/download/${attachmentId}`,
    method: 'get',
    responseType: 'blob'
  })
}

/**
 * 删除结算单附件
 * @param {Number} attachmentId - 附件ID
 * @param {Number} userId - 操作用户ID
 * @returns {Promise} 返回删除结果的Promise对象
 */
export function delete_settlement_attachment(attachmentId, userId) {
  return request({
    url: `/settlement-attachments/${attachmentId}`,
    method: 'delete',
    params: { userId }
  })
}

export default {
  upload_settlement_attachment,
  get_settlement_attachments,
  get_settlement_attachments_pagination,
  download_settlement_attachment,
  delete_settlement_attachment
}
